// Импортируем другие js-файлы
jQuery(document).ready(function($){

	//let video = document.getElementById("headerVideo");
	//video.pause();

	function animatEffect(){

		if ($(window).width() >= '1780'){

			$('.header__wrapper .two').hide();
			$('.header__wrapper .three').hide();
			$('.header__wrapper .four').hide();
			$('.header__wrapper .five').hide();
			$('.header__wrapper .six').hide();
			$('.header__trend').hide();
		
			setTimeout(function(){
				$('.header__wrapper').removeClass('full');
				$('.header__wrapper').addClass('small');
			}, 5000);
		
			setTimeout(function(){
				$('.header__wrapper .two').addClass('show').addTemporaryClass('animate__animated', 3000).addTemporaryClass('animate__bounceInRight', 3000);
				$('.header__wrapper .two').show();
			}, 5100);
		
			setTimeout(function(){
				$('.header__wrapper .three').addClass('show').addTemporaryClass('animate__animated', 3000).addTemporaryClass('animate__bounceInRight', 3000);
				$('.header__wrapper .three').show();
			}, 5300);
		
			setTimeout(function(){
				$('.header__wrapper .four').addClass('show').addTemporaryClass('animate__animated', 3000).addTemporaryClass('animate__bounceInLeft', 3000);
				$('.header__wrapper .four').show();
			}, 6200);
		
			setTimeout(function(){
				$('.header__wrapper .five').addClass('show').addTemporaryClass('animate__animated', 3000).addTemporaryClass('animate__bounceInRight', 3000);
				$('.header__wrapper .five').show();
			}, 5500);
		
			setTimeout(function(){
				$('.header__wrapper .six').addClass('show').addTemporaryClass('animate__animated', 3000).addTemporaryClass('animate__bounceInRight', 3000);
				$('.header__wrapper .six').show();
			}, 5700);
		
			setTimeout(function(){
				$('.header__trend').addClass('show').addTemporaryClass('animate__animated', 3000).addTemporaryClass('animate__flip', 3000);
				$('.header__trend').show();
			}, 7000);

		} else {

			$('.header__wrapper').addClass('small');
			$('.header__wrapper').children().addClass('show');
			
		}
	}

	$.fn.extend({ 
		addTemporaryClass: function(className, duration) {
				var elements = this;
				setTimeout(function() {
						elements.removeClass(className);
				}, duration);
				return this.each(function() {
						$(this).addClass(className);
				});
		}
	});

	$(window).on('load resize', animatEffect);

/* 	$('.header__wrapper .two').hover(function() {
		$(this).removeClass('animate__animated').removeClass('animate__bounceInRight');
	}); */

	$('#navBurger').click(function() {
		$(this).toggleClass('active');
		$('.menu').toggleClass('open');
		$('body').toggleClass('locked'); 
	});

	$('#menuClose').click(function() {
		$('.menu').removeClass('open');
		$('body').removeClass('locked');
	});

	$('#menulineBurger').click(function() {
		$(this).toggleClass('active');
		$('.menu').toggleClass('open');
		$('body').toggleClass('locked'); 
		//$('.advert__modal').toggleClass('open');
	});

	$('#navFast').click(function() {
		$('.submenu').toggleClass('open');
	});

	$('#submenuClose').click(function() {
		$('.submenu').toggleClass('open');
	});

	$(document).mouseup(e => { // отслеживаем событие клика по веб-документу
		e.preventDefault();
		var block = $('.menu__nav'); // определяем элемент, к которому будем применять условия (можем указывать ID, класс либо любой другой идентификатор элемента)
		if (!block.is(e.target) // проверка условия если клик был не по нашему блоку
				&& block.has(e.target).length === 0) { // проверка условия если клик не по его дочерним элементам
				//block.hide(); // если условия выполняются - скрываем наш элемент
				$('.menu').removeClass('open');
		}
	});

	if(window.location.pathname=='/'){
		$(window).scroll(function(){
				let docscroll=$(document).scrollTop();
				let winheight=$('.header').height();
				if ( docscroll > winheight/2 ) {
				$('#menuLine').css({'top': '0'});
			} else {
				$('#menuLine').css({'top': '-100%'});
			}
		});
		let docscroll=$(document).scrollTop();
		let winheight=$('.header').height();
		if( docscroll > winheight/2 ) {
			$('#menuLine').css({'top': '0'});
		} else {
			$('#menuLine').css({'top': '-100%'});
		}
	} else {
		let PanelContainer = $('#bx-panel').attr('unselectable');
		if(PanelContainer!==undefined){
				$('#menuLine').css('position', 'relative');
				$('.headerPage').css('margin-top', '0');
				$(window).scroll(function(){
					let docscroll=$(document).scrollTop();
					let PanelContainerH = $('#bx-panel').height();
					let FixedPanel = $('#menuLine').height();
					if ( docscroll > PanelContainerH ) {
						$('#menuLine').css('position', 'fixed');
					} else {
						$('#menuLine').css('position', 'relative');
					};
				});
		}
	};
/* 	if(window.location.pathname=='/maps/'){
		$('#menuLine').css('position', 'relative');
	}; */

	//Форма обратной связи modal__appeal
		$('.checkbox span').on('click', function () {
		$('#i-agree').trigger('click');
		if ($('.checkbox').hasClass('error')) {
				$('.checkbox').removeClass('error');
		}
	});

	$('.modal__appeal').on('click', function(e) {
		e.preventDefault();
		$(this).toggleClass('active');
		$('#modalAppeal').toggleClass('open');
	});

	$('#modalAppealClose').click(function() {
		$('.modalAppeal').removeClass('open');
		location.reload();
	});

	$('#modalAppealSend').on('click', function(e){
		e.preventDefault();

		let error,
				iAgree = $(this).closest('form').find('#i-agree'),
				form = $(this).closest('form').serialize(),
				fields = $(this).closest('form').find('.modalAppeal__field input');

		if (iAgree) {
			if (iAgree.prop('checked')) {
				console.log('0'); 
				iAgree.closest('.checkbox').removeClass('error');
				error = '';
			} else {
				console.log('1');
				iAgree.closest('.checkbox').addClass('error');
				error = 1;
			}
		}

		fields.each(function(){
			let field = $(this);
	
			if (field.val() == '') {
				if (field.prop('required')) {
					field.addClass('error');
					field.attr('placeholder','Пожалуйста заполните обязательное поле');
					error = 1;
				}
			} else {
				if (field.attr('name') == 'EMAIL') {
					 var pattern = /^([a-z0-9_\.-])+@[a-z0-9-]+\.([a-z]{2,4}\.)?[a-z]{2,4}$/i;
					 if(!pattern.test(field.val())){
						field.addClass('error'); 
						field.val('');
						field.attr('placeholder','E-mail указан не верно');
						error = 1;
					}
				}
				if (field.attr('name') == 'PHONE') {
					var pattern = /^((8|\+7)[\- ]?)?(\(?\d{3}\)?[\- ]?)?[\d\- ]{7,10}$/i;
					if(!pattern.test(field.val())){
						field.addClass('error');
						field.val('');
						field.attr('placeholder','Телефон указан не верно');
						error = 1;
					}
				}
			}
		});

		if(error == '1') {
			return false;
		} else {

			$.ajax({
				type: "POST",
				url: "/ajax/send_appeal.php",
				data: {
					form: form
				},
				cache: false,
				success: function(response){
					param = JSON.parse(response);
					console.log(param.msg);
					console.log(param.msg2);
					if(param.hasError != true){
						$('.modalAppeal__form form').removeClass('open');
						$('.modalAppeal__info').addClass('open').html(param.msg);
					} else {
					}
				}
			});
			
		};

	});

});

function vidplay() {
	let video = document.getElementById("headerVideo");
	let button = document.getElementById("headerBtn");
	if (video.paused) {
			video.play();
	} else {
			video.pause();
	}
}